import Group from 'components/utils/Group'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  grid-area: pricing;
`

function AccommodationSameRoomOptionTilePricing({ children }: PropsWithChildren) {
  return <Container gap={12} direction="vertical">
    {children}
  </Container>
}

export default AccommodationSameRoomOptionTilePricing
